export const clientLogger = {
  debug: (message?: unknown, ...optionalParams: unknown[]) => {
    if (process.env.NEXT_PUBLIC_LOG_LEVEL === 'debug') {
      console.log(message, ...optionalParams);
    }
  },
};
